import { Button } from '../Button';

interface UploadPhotoProps {
  onButtonClick?: () => void;
  icon: React.ReactNode;
  title: string;
  description: string;
  btnName?: string;
  feature: string;
}

export const EmptyScreen: React.FC<UploadPhotoProps> = ({
  onButtonClick,
  icon,
  title,
  description,
  btnName
}) => {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center max-w-md px-6">
        <div className="flex justify-center mb-6">{icon}</div>

        <h2 className="text-xl font-semibold text-[#353535] mb-4">{title}</h2>

        <p className="text-sm text-[#505050] leading-relaxed mb-6">
          {description}
        </p>
        {btnName && (
          <Button
            btnStyle="primary"
            onClick={onButtonClick}
            className="px-8 py-3 rounded-lg">
            {btnName}
          </Button>
        )}
      </div>
    </div>
  );
};
